import { render, staticRenderFns } from "./Substitutions.vue?vue&type=template&id=0aef2cd4&"
import script from "./Substitutions.vue?vue&type=script&lang=js&"
export * from "./Substitutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aef2cd4')) {
      api.createRecord('0aef2cd4', component.options)
    } else {
      api.reload('0aef2cd4', component.options)
    }
    module.hot.accept("./Substitutions.vue?vue&type=template&id=0aef2cd4&", function () {
      api.rerender('0aef2cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/substitutions/Substitutions.vue"
export default component.exports